import React from "react";

import { Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import { Link } from "ds/Button";
import { selectFeatureUsageBasedBillingEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { useAppSelector } from "Store/hooks";

import * as S from "./IntegrationForm.styles";

const CostInfo = () => {
  const intl = useIntl();
  const isUsageBilling = useAppSelector(selectFeatureUsageBasedBillingEnabled);

  return isUsageBilling ? (
    <S.CostInfoWrapper>
      <Typography.BodyText>
        {intl.formatMessage({ id: "log_forwarding_billing_note" })}
      </Typography.BodyText>
      &nbsp;
      <Link
        analyticId="view_pricing"
        href={intl.formatMessage({ id: "links.pricing" })}
      >
        {intl.formatMessage({ id: "view_pricing" })}
      </Link>
    </S.CostInfoWrapper>
  ) : null;
};

export default CostInfo;
